module.exports = __webpack_public_path__ + "img/girl-wow.c9010d3f.jpg";